import { render } from "./LatestModelReviews.vue?vue&type=template&id=6922cad6"
import script from "./LatestModelReviews.vue?vue&type=script&lang=js"
export * from "./LatestModelReviews.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__